import { AvatarSize, AvatarVariant } from '../avatar.types';
import { BasicAvatar } from './basicAvatar';
import { type JSX } from 'react';
import { getInitials } from '../../../../../utils';
import { AriaProps } from '../../../../../types';

type Props = AriaProps & {
  src?: string;
  label?: string;
  size: AvatarSize;
  fallbackLabel?: () => string;
  forceIsLoading?: boolean;
};

export const InitialsAvatar: AvatarVariant = ({
  src,
  label,
  size,
  fallbackLabel = () => getInitials(label ?? ''),
  forceIsLoading,
  ...rest
}: Props): JSX.Element => {
  return (
    <BasicAvatar
      {...rest}
      src={src}
      size={size}
      fallback={fallbackLabel()}
      label={label}
      forceIsLoading={forceIsLoading}
    />
  );
};
